<template>
	<div class="mainheadern col-11">
		<div class="hero mx-auto">
			<div class="heroheader">
				<div class="h1h text-center xmobile-8">
					<span>{{ $t('mainhero.title1', 'Tech Learning') }}</span>
					<span class="h1hdot">.</span>&nbsp;
					<span>{{ $t('mainhero.title2', 'Smart Hiring') }}</span>
					<span class="h1hdot">.</span>&nbsp;
					<span>{{ $t('mainhero.title3', 'Brands Rising') }}</span>
					<span class="h1hdot">.</span>
				</div>
				<div class="heroheadertext">{{ $t('mainhero.subtext', 'One platform to learn tech skills and hire top talent—faster, smarter.') }}</div>
			</div>
			<div class="mhcta">
				<router-link @click="$scrollToTop" to="/s/gamedesign">
					<svg width="201" height="40" viewBox="0 0 201 40" fill="none" xmlns="http://www.w3.org/2000/svg" class="img-fluid">
						<rect x="0.5" width="200" height="40" rx="20" fill="#75AE3D" />
						<path fill-rule="evenodd" clip-rule="evenodd" d="M163.517 26.3117C163.05 25.8384 163.05 25.0709 163.517 24.5975L168.055 20.0001L163.517 15.4026C163.05 14.9293 163.05 14.1618 163.517 13.6884C163.984 13.2151 164.742 13.2151 165.209 13.6884L170.594 19.143C171.061 19.6163 171.061 20.3838 170.594 20.8572L165.209 26.3117C164.742 26.7851 163.984 26.7851 163.517 26.3117Z" fill="#161616" />
						<text class="heroheaderbuttontext" :font-size="$t('mainhero.buttonfontsize', '16px')" x="86.5" y="22" dominant-baseline="middle" text-anchor="middle">{{ $t('mainhero.button1', 'Explore Courses') }}</text>
					</svg>
				</router-link>
				<a role="button" @click="learnMore">
					<svg width="162" height="42" viewBox="0 0 162 42" fill="none" xmlns="http://www.w3.org/2000/svg" class="img-fluid">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M124.517 27.3117C124.05 26.8384 124.05 26.0709 124.517 25.5975L129.055 21.0001L124.517 16.4026C124.05 15.9293 124.05 15.1618 124.517 14.6884C124.984 14.2151 125.742 14.2151 126.209 14.6884L131.594 20.143C132.061 20.6163 132.061 21.3838 131.594 21.8572L126.209 27.3117C125.742 27.7851 124.984 27.7851 124.517 27.3117Z" fill="#161616" />
						<rect x="0.5" y="1" width="161" height="40" rx="20" stroke="#737373" />
						<text class="heroheaderbuttontext" :font-size="$t('mainhero.buttonfontsize', '16px')" x="67" y="22.5" dominant-baseline="middle" text-anchor="middle">{{ $t('mainhero.button2', 'Hire Talent') }}</text>
					</svg>
				</a>
			</div>
			<div class="boxarea">
				<div class="box1"></div>
				<div class="box2"></div>
				<div class="box3"></div>
				<div class="box4"></div>
			</div>
			<div class="framearea">
				<div class="frame">
					<div class="frametitle">{{ $t('mainhero.frame1title', 'Build Skills That Pay Off') }}</div>
					<div class="frametext">{{ $t('mainhero.frame1text', 'Access age-adjusted courses in Game Design, Animation, Web Development, and more. Upskill students or yourself with industry-ready lessons designed to turn learning into earning.') }}</div>
				</div>
				<div class="frame">
					<div class="frametitle">{{ $t('mainhero.frame2title', 'Hire Smarter, Faster') }}</div>
					<div class="frametext">{{ $t('mainhero.frame2text', 'Automate recruitment with tools that help you find and assess top talent efficiently. Whether you`re a company or school, connect with the right people — effortlessly.') }}</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script lang="ts" setup>
defineProps({
	options: Object
})


const learnMore = () => {
	const classid = '.partnersarea';
	const yOffset = -150;
	const element = document.querySelector(classid);
	const y = element.getBoundingClientRect().top + window.scrollY + yOffset;

	window.scrollTo({ top: y, behavior: 'smooth' });
}
</script>
<style scoped lang="scss">
.mainheadern {}

.hero {
	display: flex;
	padding: 0px 80px;

	@media (max-width: 576px) {
		padding: 0px 0px;
	}

	flex-direction: column;
	align-items: center;
	gap: 32px;
	align-self: stretch;
}

.heroheader {
	display: flex;

	@media (min-width: 992px) {
		max-width: 956px;
	}

	flex-direction: column;
	align-items: center;
	gap: 24px;

}

.boxarea {
	display: flex;
	align-items: flex-start;
	gap: -30px;

	@media (max-width: 992px) {
		transform: scale(0.65);
	}

	@media (max-width: 576px) {
		transform: scale(0.39);
	}

}

.box1 {
	width: 220px;
	height: 220px;

	@media (max-width: 992px) {
		xtransform: scale(0.7);
	}

	transform: rotate(1deg);
	aspect-ratio: 1/1;
	border-radius: 24px;
	xbackground: #515151;
	background: url(@/assets/img/main/box1.jpg) lightgray 50% / cover no-repeat;
}

.box2 {
	width: 220px;
	height: 220px;
	transform: rotate(-2deg);
	aspect-ratio: 1/1;
	border-radius: 24px;
	xbackground: #929292;
	background: url(@/assets/img/main/box2.jpg) lightgray 50% / cover no-repeat;
}

.box3 {
	width: 220px;
	height: 220px;
	transform: rotate(2.5deg);
	aspect-ratio: 1/1;
	border-radius: 24px;
	xbackground: #6D6D6D;
	background: url(@/assets/img/main/box3.jpg) lightgray 50% / cover no-repeat;
}

.box4 {
	width: 220px;
	height: 220px;
	transform: rotate(-0.7deg);
	aspect-ratio: 1/1;
	border-radius: 24px;
	xbackground: #515151;
	background: url(@/assets/img/main/box4.jpg) lightgray 50% / cover no-repeat;
}

.framearea {
	display: flex;

	@media (max-width: 576px) {
		display: block;
	}

	@media (min-width: 992px) {
		max-width: 954px;
	}

	justify-content: center;
	align-items: flex-start;
	gap: 72px;
}

.frame {
	display: flex;
	padding-top: 32px;
	flex-direction: column;
	align-items: flex-start;
	gap: 24px;
	flex: 1 0 0;
}

.frametitle {
	align-self: stretch;
	color: #000;
	font-family: Play;
	font-size: 32px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	letter-spacing: 0.1px;
}

.frametext {
	align-self: stretch;
	color: #000;
	font-family: Roboto;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	letter-spacing: 0.1px;
}

.h1h {
	@media (min-width: 992px) {
		max-width: 710px;
	}

	color: #000;
	text-align: center;
	font-family: Play;
	font-size: 52px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	letter-spacing: 0.1px;
}

.h1hdot {
	color: var(--Dark-Green, #4F7529);
	font-family: Play;
	font-size: 52px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	letter-spacing: 0.1px;
}

.heroheadertext {
	color: #000;
	text-align: center;
	font-family: Roboto;
	font-size: 20px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	letter-spacing: 0.1px;
	align-self: stretch;
}


.heroheaderbutton:hover text,
.heroheaderbutton:hover path {
	fill: #fff;
}

.heroheaderbuttontext {
	fill: var(--Off-black-100, #161616);
	text-align: center;
	font-family: Play;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	letter-spacing: 0.1px;
}

.mhcta {
	display: flex;
	justify-content: center;
	align-items: flex-start;
	gap: 16px;
}
</style>